import MapComponent from "../components/MapComponent/MapComponent"
import { EuphaWorldContainer } from '../styles/Layout.style'

const EuhpaWorld = () => {
    return (
      <EuphaWorldContainer>

<MapComponent />
      </EuphaWorldContainer>
      
    )
}

export default EuhpaWorld